import { useContext } from 'react'
import {
  RecursiveItemContainer,
  RecursiveItemTitle
} from '../../../styled-components.js'
import { DefineIcon } from './quick-select-icons.jsx'
import { Confirm } from '../../../../../atoms/icons/essentials/index.js'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes.js'
import { QuickSelectContext } from './quick-select-context.jsx'
import TruncateMiddleText from '../../../../../../truncate-middle/index.jsx'

const QuickSelectItem = ({
  item,
  handleCallback = null,
  selectedItem = null,
  itemType = null,
  ...props
}) => {
  const { setIsOpen } = useContext(QuickSelectContext)

  const handleClick = () => {
    item?.onClick && item.onClick(item)

    handleCallback && handleCallback(item)

    setIsOpen(false)
  }

  const handleCopy = (e) => {
    try {
      const element = e.currentTarget || e.target
      const textToCopy = element.getAttribute('data-text')

      if (!textToCopy) return

      if (e.clipboardData) {
        e.preventDefault()
        e.clipboardData.setData('text/plain', textToCopy)
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        // fallback
        e.preventDefault()
        navigator.clipboard.writeText(textToCopy)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const isSelected = selectedItem === item.id

  return (
    <RecursiveItemContainer
      onClick={handleClick}
      data-selected={isSelected}
      {...props}
    >
      {item?.icon ?? <DefineIcon itemType={itemType ?? item?.type} />}
      <RecursiveItemTitle onCopy={handleCopy} data-text={item.name}>
        <TruncateMiddleText text={item.name} widthOffSet={20} offset={10} />

        {isSelected && <Confirm size={iconSizeOptions['ICON-S']} />}
      </RecursiveItemTitle>
    </RecursiveItemContainer>
  )
}

export default QuickSelectItem
